function loading(flag) {
	$('.loading').toggleClass('hide',!flag);
	$('.play-button').toggleClass('hide',flag);
}

var playcb, pausecb;
var paused = true;
var started = false;

function play(cb) {
	playcb = cb;
}

function pause(cb) {
	pausecb = cb;
}

function triggerPlay() {
	paused = false;
	playcb();
	$play_button.removeClass('paused');
}

function triggerPause() {
	paused = true;
	pausecb();
	$play_button.addClass('paused');
}

// =======================================================
// INITIAL SETUP & BIND
// =======================================================

// bind
$('.play-button').on('click', function() {
	started = true;
	$(this).addClass('offscreen');
	$('.control').removeClass('nothing');
	setTimeout(function() {
		$('[remove-on-start]').remove();
		$('[unhide-on-start]').removeClass('hidden');
	}, 1001);
	triggerPlay();
	$('body').off('mousemove');
	$(this).off('click');
});

var window_width = $(window).width(),
	window_height = $(window).height(),
	$shadow = $('.sg-shadow');
$('body').on('mousemove', function(e) {
	var x = (e.clientX / window_width  * 20 - 10) * -1;
	var y = (e.clientY / window_height * 20 - 10) * -1;
	$shadow.css('transform', 'translate3d(' + x+'px,' + y+'px,' + '0px)');
});

var canvas = $('canvas')[0];
window.max_width = $(window).width();
window.max_height = $(window).height();

$(window).resize(function() {
	window_width = $(this).width();
	window_height = $(this).height();
	canvas.width = window_width;
	canvas.height = window_height;
	window.max_width = Math.max(window_width, max_width);
	window.max_height = Math.max(window_height, max_height);
});

var $modal = $('.modal');
$('[data-open-modal]').click(function(e) {
	$modal.removeClass('hide');
});

$('.modal-innards').click(function(e) {
	e.stopPropagation();
});

$modal.click(function(e) {
	$modal.addClass('hide');
});

// =======================================================
// PLAYER CONTROLS
// =======================================================

var $play_button = $('[data-play]');
$play_button.on('click', function(e) {
	if (!started) return;
	if (paused) {
		triggerPlay();
	} else {
		triggerPause();
	}
});

$(window).keyup(function(e) {
	if (!started) return;
	if (e.keyCode == 32) {
		if (paused) {
			triggerPlay();
		} else {
			triggerPause();
		}
	}
});

var $progress = $('.progress-amount');
function progress(amt) {
	if (!paused) {
		$progress.css('right', 100 - (amt * 100) + '%');
	}
}

// =======================================================
// END
// =======================================================

function finished() {
	$('canvas').addClass('finished');
	$('.post-controls').addClass('show');
}

module.exports = {
	play: play,
	pause: pause,
	loading: loading,
	progress: progress,
	finished: finished
};